























































































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import GenericAdd from "@/core/Generics/GenericAdd";
import ProjectType from "@/models/porposal/projectType.Model";
@Component
export default class ProjectTypeAdd extends GenericAdd<ProjectType> {
  constructor() {
    super();
    this.controller = "ProjectTypes";
    this.model = new ProjectType();
 
  }

}
